import { createReducer } from 'typesafe-actions'
import { Reducer } from 'redux'
import {
  PrivacyPolicyActionTypes,
  PrivacyPolicyState,
} from './types'

export const privacyPolicyInitialState: PrivacyPolicyState = {
  privacyPolicy: { htmlDocument: '' },
  term: { htmlDocument: '' }
}

export const privacyPolicyReducer: Reducer<PrivacyPolicyState> = createReducer<
  PrivacyPolicyState
>(privacyPolicyInitialState, {
  [PrivacyPolicyActionTypes.TERM_REQUEST]: (state: PrivacyPolicyState) => ({
    ...state
  }),
  [PrivacyPolicyActionTypes.TERM_SUCCESS]: (
    state: PrivacyPolicyState,
    action
  ) => ({
    ...state,
    ...action.payload
  }),
  [PrivacyPolicyActionTypes.TERM_FAIL]: (state: PrivacyPolicyState) => ({
    ...state
  }),

  [PrivacyPolicyActionTypes.PRIVACY_POLICY_REQUEST]: (
    state: PrivacyPolicyState
  ) => ({
    ...state
  }),
  [PrivacyPolicyActionTypes.PRIVACY_POLICY_SUCCESS]: (
    state: PrivacyPolicyState,
    action
  ) => ({
    ...state,
    ...action.payload
  }),
  [PrivacyPolicyActionTypes.PRIVACY_POLICY_FAIL]: (
    state: PrivacyPolicyState
  ) => ({
    ...state,
    privacyPolicy: { htmlDocument: '' },
    term: { htmlDocument: '' }
  })
})
